import { api } from '@/shared/redux/api/_generated/api/audit-api.generated';

export const auditApi = api.enhanceEndpoints({
  addTagTypes: ['AuditLogs'],
  endpoints: {
    ReadAllAuditLogs: {
      providesTags: [{ type: 'AuditLogs', id: 'LIST' }],
    },
    ReadAuditLogsCount: {
      providesTags: [{ type: 'AuditLogs', id: 'LIST' }],
    },
  },
});

export const {
  useReadAllAuditLogsQuery,
  useReadAuditLogsCountQuery,
  useExportAuditLogsCsvMutation,
} = auditApi;
